import ColaboradorModel from "../models/colaboradorModel";

import { iServiceCached } from "./base/iServiceCached";

class ColaboradorService extends iServiceCached<ColaboradorModel> {
    constructor() {
        super("Colaborador");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.nome,
            email: p.email,
        }));
    }
}

export default new ColaboradorService();
